var _circle, _rect, _rect2, _text, _text2, _path, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 30,
    height: 20,
    rx: 2,
    ry: 2,
    fill: "#0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 26,
    height: 16,
    rx: 1,
    ry: 1,
    fill: "#000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 24,
    fill: "#0f0",
    fontFamily: "monospace",
    fontSize: 5
  }, "HACK")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 30,
    fill: "#0f0",
    fontFamily: "monospace",
    fontSize: 5
  }, "MODE")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12c5 0 30 0 30 0l-2 3h-26z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13c4 0 28 0 28 0l-1 1h-26z",
    fill: "#0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10c-2 0-3 1-3 2h6c0-1-1-2-3-2z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 35c3 3 21 3 24 0l-12-1z",
    fill: "#333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 6,
    r: 1,
    fill: "#f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacker);
export default __webpack_public_path__ + "static/media/hacker.6cf30faacbd0fa8e01492c2cf3bd6f6b.svg";
export { ForwardRef as ReactComponent };